import fetch from 'isomorphic-fetch';

import { showErrorBar } from 'actions/errorBar';
import { updateResetPasswordIsFetching } from 'actions/resetPassword';
import { ERROR, SUCCESS } from 'constants/error-severities';
import {
  HEADER_CONTENT_TYPE,
  STATUS_BAD_REQUEST,
  STATUS_INTERNAL_SERVER_ERROR,
  STATUS_NOT_FOUND,
} from 'constants/http';
import { JSON as JSON_MIME } from 'constants/mimes';
import { MY_VIDEOS_PAGE } from 'constants/routes';

export function postResetPasswordCreator(email) {
  return async dispatch => {
    try {
      dispatch(updateResetPasswordIsFetching(true));

      const resp = await fetch('/api/auth/resetPassword', {
        credentials: 'include',
        headers: { [HEADER_CONTENT_TYPE]: JSON_MIME },
        method: 'POST',
        body: JSON.stringify({ email }),
      });

      if (resp.status == 403) {
        throw new Error(`This account must log in via SSO`);
      }

      if (resp.status >= 400) {
        throw new Error(
          `Oops! Something went wrong - HTTP response: ${resp.status}`
        );
      }

      switch (resp.status) {
        case STATUS_BAD_REQUEST:
          throw new Error('The email provided was incorrect.');
        case STATUS_INTERNAL_SERVER_ERROR:
          throw new Error(
            'There was an error on our server. :-( ' +
              'Please try again in a bit or contact support@loom.com.'
          );
        default:
          break;
      }

      dispatch(updateResetPasswordIsFetching(false));
      dispatch(showErrorBar(SUCCESS, 'Email en route. See you in a minute!'));
    } catch (err) {
      dispatch(updateResetPasswordIsFetching(false));
      dispatch(showErrorBar(ERROR, err));
    }
  };
}

export function putResetPasswordCreator(password, token) {
  return async dispatch => {
    try {
      dispatch(updateResetPasswordIsFetching(true));

      const resp = await fetch('/api/auth/resetPassword', {
        credentials: 'include',
        headers: { [HEADER_CONTENT_TYPE]: JSON_MIME },
        method: 'PUT',
        body: JSON.stringify({ password, token }),
      });

      if (resp.status >= 400) {
        throw new Error(
          `Oops! Something went wrong - HTTP response: ${resp.status}`
        );
      }

      switch (resp.status) {
        case STATUS_BAD_REQUEST:
          throw new Error('We cannot accept the password you provided.');
        case STATUS_INTERNAL_SERVER_ERROR:
          throw new Error(
            'There was an error on our server. :-( ' +
              'Please try again in a bit or contact support@loom.com.'
          );
        case STATUS_NOT_FOUND:
          throw new Error('This reset password link is invalid.');
        default:
          break;
      }

      dispatch(updateResetPasswordIsFetching(false));
      dispatch(
        showErrorBar(
          SUCCESS,
          'Successfully reset your password! Redirecting you in a second.'
        )
      );

      window.setTimeout(() => {
        window.location.href = MY_VIDEOS_PAGE;
      }, 1000);
    } catch (err) {
      dispatch(updateResetPasswordIsFetching(false));
      dispatch(showErrorBar(ERROR, err));
    }
  };
}
